"use client";

import styles from "./GreyCards.module.css";
import MaxWidth from "@/components/MaxWidth";
import { stripOuterPTag } from "@/lib/utils/stripOuterPTag";
import { isExternalUrl } from "@/lib/utils/isExternalUrl";
import { Header3, P2, Link } from "@bumble/ui-kit";
export default function GreyCards({
  data
}: any) {
  const cards = data?.cards ?? [];
  if (cards.length === 0) {
    return null;
  }
  return <MaxWidth>
      <div className={styles.wrapper}>
        {cards.map((card: any, index: number) => <div key={index} className={styles.card}>
            <Header3>{card.title}</Header3>
            <br />
            <span className={styles.description}>
              <P2 html={stripOuterPTag(card.text)} />
            </span>
            <br />
            <span className={styles.cta}>
              {card.cta?.link ? <Link href={card.cta?.link} title={card.cta.text} extraClass="" isDecorated={false} target={isExternalUrl(card.cta?.link) ? "_blank" : "_self"} onClick={() => {}}>
                  {card.cta.text}
                </Link> : null}
            </span>
          </div>)}
      </div>
    </MaxWidth>;
}